// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"12":"make","621":"constructor"}[chunkId] + "." + {"12":"52b32f9d","621":"6f3c043b"}[chunkId] + ".css";
};